import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import appConstant from '../../appConstants';
import PageNotFound from '.';

// Using hardcoded colors since this page should be independent of the theme
const styles = {
  homeButton: {
    width: 150,
    marginTop: 16,
    alignSelf: 'center',
    backgroundColor: 'rgba(12, 107, 185, 1)',
    textTransform: 'none',
    height: 44,
    textDecoration: 'none',
    fontWeight: 600,
    color: '#FFFFFF',
    fontSize: 18
  }
};

const ServerError = (props) => {
  const { classes } = props;
  return (
    <PageNotFound
      errorLabel="Something went wrong"
      errorDescription="We’re having trouble connecting to the server right now."
      statusCode="">
      <Button
        color="primary"
        variant="contained"
        classes={{ root: classes.homeButton }}
        href={appConstant.NAV_URLS.IBPLANNING_HOME}>
        Reload
      </Button>
    </PageNotFound>
  );
};

export default withStyles(styles)(ServerError);
